var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("path",{"d":"M4.72590714,16.8142085 L4.72590714,8.40611983 L6.82846026,8.40611983 L7.10709394,5.50864591 L4.72590714,5.50864591 L4.72947936,4.05843232 C4.72947936,3.3027265 4.79452366,2.89780206 5.77777907,2.89780206 L7.09220967,2.89780206 L7.09220967,0 L4.98935886,0 C2.46349687,0 1.57445894,1.40558658 1.57445894,3.76934121 L1.57445894,5.50897405 L0,5.50897405 L0,8.40644797 L1.57445894,8.40644797 L1.57445894,16.8142085 L4.72590714,16.8142085 Z","id":"Path","fill":"#8B97A6"}))]);
}

Facebook.defaultProps = {"width":"8px","height":"17px","viewBox":"0 0 8 17","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;
